export const PHONE_VALIDATION_PATTERN = '^[- +()0-9]+$';


export const ALPHANUMERIC = /^\w+$/
export const ALPHABETIC = /^[A-Za-z]+$/;

/**
 * Regex that allows for alphabetical characters 
 * hyphens, underscores, at symbols, dots, hashtags, plus signs and empty space
 */
export const ALPHABETIC_FREE_TEXT = /^[A-Za-z-_@.#&+ ]+$/;

/**
 * Regex that allows for alphanumeric characters 
 * hyphens, underscores, at symbols, dots, hashtags, plus signs and empty space
 */
export const ALPHANUMERIC_FREE_TEXT = /^[\w\-_@.#&+ ]+$/;


/**
 * Regex that allow international names with characters from any language
 * commas, dots, apostrophes, hyphens and empty space
 */
export const UNICODE_NAME = /^[\p{L}\p{M}\d ,.'-]+$/u;
